// 嘉宾详情内容区（可复用于 Discover 和 历史详情页）
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiBaseUrl } from '../utils/request';
import { formatHometown, formatCity } from '../utils/region';

export default function GuestDetailContent({ user, browse }) {
  const navigate = useNavigate();
  const [enlargePhoto, setEnlargePhoto] = useState(null);
  const getPhotoSrc = (photo) => {
    if (typeof photo !== 'string') return '';
    return photo.startsWith('/uploads/') ? apiBaseUrl + photo : photo;
  };

  if (!user) return null;

  const locked = browse?.locked;

  return (
    <>
      <div style={{ position: 'relative' }}>
      <div className="card" style={{ display: 'flex', alignItems: 'flex-start', gap: 16 }}>
        <img
          src={user.avatar || 'https://via.placeholder.com/100'}
          alt={user.nickname}
          style={{ width: 80, height: 80, borderRadius: '50%', flexShrink: 0, objectFit: 'cover' }}
        />
        <div style={{ flex: 1, minWidth: 0 }}>
          <h2 style={{ fontSize: 22, marginBottom: 6 }}>{user.nickname}</h2>
          <div style={{ fontSize: 14, color: '#666' }}>
            {[user.age && `${user.age}岁`, user.job].filter(Boolean).join(' | ')}
          </div>
        </div>
      </div>

      {user.intro && (
        <div className="card">
          <h3 style={{ marginBottom: 10, fontSize: 16 }}>关于我</h3>
          <p style={{ lineHeight: 1.7, color: '#333', margin: 0 }}>{user.intro}</p>
        </div>
      )}

      {user.ideal_type && (
        <div className="card">
          <h3 style={{ marginBottom: 10, fontSize: 16 }}>我的理想型</h3>
          <p style={{ lineHeight: 1.7, color: '#333', margin: 0 }}>{user.ideal_type}</p>
        </div>
      )}

      <div className="card">
        <h3 style={{ marginBottom: 12, fontSize: 16 }}>基本资料</h3>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
          {[
            user.height && `📏 ${user.height}cm`,
            user.zodiac && `⭐ ${user.zodiac}`,
            user.school && user.education ? `🎓 ${user.school}·${user.education}` : (user.school ? `🎓 ${user.school}` : (user.education ? `🎓 ${user.education}` : null)),
            user.job && `💼 ${user.job}`,
            user.annual_salary && `💰 年薪${user.annual_salary}`,
            user.marriage && `💍 ${user.marriage}`,
            user.dating_goal && `🎯 ${user.dating_goal}`,
            user.hometown && formatHometown(user.hometown) ? `🏡 ${formatHometown(user.hometown)}` : null,
            user.city && formatCity(user.city) ? `📍 ${formatCity(user.city)}` : null,
            user.housing && user.housing !== '暂无' && `🏠 ${user.housing}`,
            user.car && user.car !== '暂无' && `🚗 ${user.car}`,
          ].filter(Boolean).map((item, idx) => (
            <span
              key={idx}
              style={{
                display: 'inline-block',
                padding: '8px 12px',
                margin: '2px 4px 2px 0',
                borderRadius: 12,
                fontSize: 13,
                color: '#4f5563',
                background: '#f6f8ff',
                border: '1px solid #e8edff',
                lineHeight: 1.4,
              }}
            >
              {item}
            </span>
          ))}
        </div>
      </div>

      {user.photos && user.photos.length > 0 && (
        <div className="card">
          <h3 style={{ marginBottom: 12, fontSize: 16 }}>照片</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {user.photos.map((photo, index) => (
              <img
                key={index}
                src={getPhotoSrc(photo)}
                alt={`照片${index + 1}`}
                onClick={() => setEnlargePhoto(getPhotoSrc(photo))}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && setEnlargePhoto(getPhotoSrc(photo))}
                style={{
                  width: '100%',
                  maxHeight: 400,
                  objectFit: 'contain',
                  borderRadius: 8,
                  cursor: 'pointer',
                }}
              />
            ))}
          </div>
        </div>
      )}

      {locked && (
        <div
          style={{
            position: 'absolute',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            borderRadius: 12,
            background: 'rgba(255,255,255,0.88)',
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 24,
            zIndex: 40,
            textAlign: 'center',
            boxSizing: 'border-box',
            minHeight: 320,
          }}
        >
          <p style={{ fontSize: 17, fontWeight: 600, color: '#333', marginBottom: 10, lineHeight: 1.5 }}>
            {browse?.message || '查看资料受限'}
          </p>
          {browse?.isMember && browse?.exhausted && (
            <p style={{ fontSize: 14, color: '#888', marginBottom: 0 }}>明天再来刷新浏览次数</p>
          )}
          {!browse?.isMember && browse?.exhausted && (
            <button
              type="button"
              className="btn btn-primary"
              style={{ marginTop: 20, minWidth: 160 }}
              onClick={() => navigate('/membership')}
            >
              开通会员
            </button>
          )}
        </div>
      )}

      {enlargePhoto && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.9)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1100,
            padding: 16,
          }}
          onClick={() => setEnlargePhoto(null)}
        >
          <img
            src={enlargePhoto}
            alt="放大查看"
            onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
          />
        </div>
      )}
      </div>
    </>
  );
}
